/** Ported from src/components/ui/Chip.tsx — a display pill, not a control. */
export default function Chip({ label, tone = 'neutral' }: {
  label: string;
  tone?: 'success' | 'primary' | 'neutral';
}) {
  return <span className={`chip chip-${tone}`}>{label}</span>;
}
